<script lang="ts" setup>
  import { useAuthStore } from '@tundr/auth';
  import { DropdownItem } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { SidebarUserMenu } from '@tundr/sidebar';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { computed } from 'vue';
  import { useLogout } from '@bo/shared/composables/use-logout';

  type UserMenuProps = {
    collapsed: boolean;
  };

  defineProps<UserMenuProps>();

  const { t } = useLocale('common');
  const authStore = useAuthStore();

  const { onLogout } = useLogout();

  const userDisplayName = computed(() =>
    `${authStore.user?.firstName ?? ''} ${authStore.user?.lastName ?? ''}`.trim(),
  );
</script>

<template>
  <SidebarUserMenu
    :collapsed="collapsed"
    :user-name="userDisplayName"
    :trigger-aria-label="t('profile_menu.actions.open_user_menu.aria_label')"
  >
    <DropdownItem
      :icon="TUNDR_ICONS.SIGNOUT"
      @click="() => onLogout()"
      test-id="menu-item-logout"
      :label="t('profile_menu.actions.logout.label')"
    />
  </SidebarUserMenu>
</template>
